import store from '@/store'
const toast = (severity = 'info') => (message, duration) => {
	return store.dispatch(`toast/push`, { message, severity, duration })
}

export default {
	methods: {
		toast: toast(),
		toastWarn: toast('warning'),
		toastErr: toast('error')
	}
}
